import React from 'react';
import { Loader2, Wallet } from 'lucide-react';

export function AdminPayoutsTab({ driverPayouts, goToDriver, quickPayoutConfirm, setQuickPayoutConfirm, quickPayoutLoading, handleQuickPaypalPayout }) {
  return (
    <div className="bg-white rounded-xl border border-slate-100 overflow-hidden" data-testid="driver-payouts-tab">
      <div className="px-5 py-3 border-b border-slate-100">
        <h2 className="font-bold text-sm text-slate-800">Fahrer-Auszahlungen ({driverPayouts.length} Fahrer mit Buchungen)</h2>
      </div>
      {driverPayouts.length === 0 ? (
        <div className="p-12 text-center text-slate-400">Keine Auszahlungen fällig</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="text-left px-5 py-2.5 text-xs font-semibold text-slate-500 uppercase">Fahrer</th>
                <th className="text-left px-5 py-2.5 text-xs font-semibold text-slate-500 uppercase">Buchungen</th>
                <th className="text-left px-5 py-2.5 text-xs font-semibold text-slate-500 uppercase">Gesamt verdient</th>
                <th className="text-left px-5 py-2.5 text-xs font-semibold text-slate-500 uppercase">Ausgezahlt</th>
                <th className="text-left px-5 py-2.5 text-xs font-semibold text-slate-500 uppercase">Offen</th>
                <th className="text-left px-5 py-2.5 text-xs font-semibold text-slate-500 uppercase">Zahlungskonten</th>
                <th className="text-left px-5 py-2.5 text-xs font-semibold text-slate-500 uppercase">Aktion</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {driverPayouts.map(dp => (
                <tr key={dp.driver_id} className="hover:bg-slate-50">
                  <td className="px-5 py-3">
                    <p className="font-medium text-slate-800 text-sm">{dp.driver_name}</p>
                    <p className="text-xs text-slate-400">{dp.driver_email}</p>
                  </td>
                  <td className="px-5 py-3 text-sm text-slate-700">{dp.total_bookings}</td>
                  <td className="px-5 py-3 font-medium text-sm text-slate-800">{dp.total_earned} EUR</td>
                  <td className="px-5 py-3 text-sm text-emerald-600">{dp.total_paid} EUR</td>
                  <td className="px-5 py-3">
                    <span className={`font-bold text-sm ${dp.balance_owed > 0 ? 'text-orange-600' : 'text-slate-400'}`}>{dp.balance_owed} EUR</span>
                  </td>
                  <td className="px-5 py-3">
                    <div className="space-y-0.5">
                      {dp.paypal_email && <p className="text-xs text-blue-600">PayPal: {dp.paypal_email}</p>}
                      {dp.instapay_number && <p className="text-xs text-green-600">InstaPay: {dp.instapay_number}</p>}
                      {dp.vodafone_cash_number && <p className="text-xs text-red-600">VodaCash: {dp.vodafone_cash_number}</p>}
                      {!dp.paypal_email && !dp.instapay_number && !dp.vodafone_cash_number && <span className="text-xs text-slate-300">-</span>}
                    </div>
                  </td>
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-2">
                      <button onClick={() => goToDriver(dp.driver_id)} className="px-3 py-1.5 bg-orange-50 text-orange-600 rounded-lg text-xs font-medium hover:bg-orange-100" data-testid={`payout-detail-${dp.driver_id}`}>
                        Details
                      </button>
                      {dp.paypal_email && dp.balance_owed > 0 && (
                        <>
                          {quickPayoutConfirm === dp.driver_id ? (
                            <div className="flex items-center gap-1">
                              <button onClick={() => handleQuickPaypalPayout(dp)} disabled={quickPayoutLoading === dp.driver_id}
                                className="px-2 py-1.5 bg-blue-600 text-white rounded-lg text-xs font-semibold hover:bg-blue-700 disabled:opacity-50 flex items-center gap-1"
                                data-testid={`payout-paypal-confirm-${dp.driver_id}`}>
                                {quickPayoutLoading === dp.driver_id ? <Loader2 size={10} className="animate-spin" /> : null}
                                {dp.balance_owed} EUR senden
                              </button>
                              <button onClick={() => setQuickPayoutConfirm(null)} className="px-2 py-1.5 bg-slate-100 text-slate-600 rounded-lg text-xs hover:bg-slate-200">X</button>
                            </div>
                          ) : (
                            <button onClick={() => setQuickPayoutConfirm(dp.driver_id)}
                              className="px-3 py-1.5 bg-blue-50 text-blue-600 rounded-lg text-xs font-medium hover:bg-blue-100 flex items-center gap-1"
                              data-testid={`payout-paypal-quick-${dp.driver_id}`}>
                              <svg viewBox="0 0 24 24" className="w-3 h-3 fill-current"><path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797H9.603c-.564 0-1.04.408-1.13.964L7.076 21.337z"/></svg>
                              PayPal
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
